export default "__VITE_ASSET__BYtoPmc4__"